package horcrux.frontend.common.views.components.containers

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.configs.StaticContentConfigs
import horcrux.frontend.common.views.org.Logo
import horcrux.frontend.common.views.org.LogoProps
import horcrux.frontend.common.withDefaultCSS
import mui.system.sx
import react.FC
import react.PropsWithChildren
import web.cssom.AlignItems
import web.cssom.JustifyContent
import web.cssom.plus
import web.cssom.pt

external interface ViewWithLogoProps : PropsWithChildren {
    var globalAppState: GlobalAppState
    var logoPropsMaybe: LogoProps?
}

val ViewWithLogo = FC<ViewWithLogoProps> { props ->
    VStack {
        this.sx {
            this.alignItems = AlignItems.center
            this.justifyContent = JustifyContent.center
        }
        Logo {
            props
                .logoPropsMaybe
                ?.let { +it }
                ?: run {
                    this@Logo.widthMaybe = 200.0
                    this@Logo.sx {
                        this.marginTop = StaticContentConfigs.APP_BAR_HEIGHT.plus(5.pt)
                    }
                }
        }
        this.withDefaultCSS()
        +props.children
    }
}
